import { BasicDto, IdObject } from "../../_shared/models/basicDto";
import { SelectOption } from "../../_shared/models/option";
import { ActivityNameAndDateDto } from "../../activity/models/activity";
import { BasicMailDto } from "../../communication/models/mail";
import { UserBasicDto } from "../../users/models/user";
import { AccountListDto } from "./account";
import { FinancialPostListDto } from "./financialPost";
import { TransactionLineListDto } from "./transactionLine";
import { TransactionVatRosterListDto } from "./vat-roster";

export interface TransactionBasicDto extends IdObject<number> {
  WorkingyearId: number | null;
  TypeId: number | null;
  ActivityId: number | null;
  MoreInfo: string;
  Description: string;
  InherritId: number | null;
  OrganizationId: number | null;
  Month: number | null;
  Year: number | null;
  CoupledActivity: number | null;
  HasVat: boolean | null;
  VatReverseCharge: boolean | null;
  WhoPersonId: number | null;
  WhoAddressId: number | null;
  SequenceNumber: number | null;
  AccountId: number | null;
  FinancialPostId: number | null;
  Bankextract: string;
  WhoTypeId: number | null;
  VatPercentage: number | null;
  TransactionDate: Date | null;
  InvoiceDate: Date | null;
  InvoiceNumber: string;
  InvoiceDueDate: Date | null;
  DocumentTypeId: number | null;
  DocumentReferenceNumber: string;
  DocumentReferenceNumberOwnOrRelated: string;
  DocumentReferenceNumberRelated: string;
  DocumentReason: string;
  DocumentUrl: string;
  InvoiceSendDate: Date | null;
  AccessKey: string;
  InvoiceSequenceNumber: number | null;
  ProductTypeId: number | null;
  DeliveryTypeId: number | null;
  HasMultipleVat: boolean | null;
  DeductibleVatPercentage: number | null;
  RelatedTransactionId: number | null;
  RelatedTransactionDate: Date | null;
  MemberId: number | null;
  FamilyMemberIds: number[] | null;
  HasRelatedTransaction: boolean;
  PayedAmount: number | null;
  VatDeclarationId: number | null;
  DeliveryDate: Date | null;
  ExcludeFromVat: boolean;
  IsDagontvangst: boolean;
  Converted: boolean | null;
  WhoName: string;
  DateClosed: Date | null;
  UserIdClosed: number | null;

  NotPayedAmount: number | null;
  Amount: number | null;
  VatAmount: number | null;
  AmountExclVat: number | null;

  HasInvoice: number | null;
  IsImport: boolean;

  PeppolDocumentId: string | null;
  PeppolSendDate: Date | null;
  UBL: string | null;
  OrderNumber: string | null;
  IsPayed: boolean;

  EditApprovedByUserId: number | null;
  EditApprovedByUser: UserBasicDto | null;
  EditApprovedDate: Date | null;

  UblExportDate: Date | null;
  UblExportError: string | null;

  // Wordt gezet door de backend wanneer een inkomend Peppol-UBL niet leesbaar is.
  // De UI toont een "Fout"-badge zodat de gebruiker weet dat handmatige actie nodig is.
  UblParseError: string | null;

  TransactionType: BasicDto<number>;

  NoVatArticle: number | null;
}

export interface TransactionForListDto extends TransactionBasicDto {
  TransactionLines: TransactionLineListDto[];
  //ProductDeliveryType: ProductDeliveryTypeListDto;
  //ProductType: ProductTypeListDto;
  //WhoAddress: AddressListDto;
  //WhoPerson: PersonNameDto;
  Account: AccountListDto;
  FinancialPost: FinancialPostListDto;
  Activity: ActivityNameAndDateDto;
  //WhoType: TransactionWhoTypeListDto;
  User: UserBasicDto;
  RelatedTransactionDocumentUrl: string | null;
  RelatedTransactionUBL: string | null;
}

export interface TransactionListDto extends TransactionBasicDto {
  TransactionLines: TransactionLineListDto[];
  //  ProductDeliveryType: ProductDeliveryTypeListDto;
  //  ProductType: ProductTypeListDto;
  //  WhoAddress: AddressListDto;
  //  WhoPerson: PersonBasicDto;
  Account: AccountListDto;
  //  WhoType: TransactionWhoTypeListDto;
  FinancialPost: FinancialPostListDto;
  User: UserBasicDto;
  Activity: ActivityNameAndDateDto;

  RelatedTransactionDocumentUrl: string | null;
  RelatedTransactionUBL: string | null;
}

export interface TransactionVatRosterAmountDto extends TransactionListDto {
  AmountRoster: number | null;
}

export interface TransactionDto extends TransactionListDto {
  ErrorMessage: string;

  //Organization: OrganizationDto;
  //Activity: ActivityListDto;
  //WorkingYear: WorkingYearListDto;
  //VatDeclaration: VatDeclarationListDto;
  //TransactionReceipts: TransactionReceiptDto[];
  //TransactionSpendings: TransactionSpendingDto[];
  VatRosters: TransactionVatRosterListDto[];
}
export enum TransactionTypeEnum {
  schuld = 1,
  vordering,
  ontvangst,
  uitgave,
  uitgereikteCreditnota = 6,
  ontvangenCreditnota,
  dagOntvangsten = 8,
  geldoverdracht = 9,
}

export enum WhoTypeEnum {
  BelgischePersoon = 1,
  BelgischeOrganisatieZonderBtw = 2,
  BelgischeOrganisatieMetBtw = 3,
  EuPersoon = 4,
  EuOrganisatieZonderBtw = 5,
  EuOrganisatieMetBtw = 6,
  NietEuPersoon = 7,
  NietEuOrganisatie = 8,
}

export interface TransactionInvoiceNrDto {
  Number: string;
  SequenceNr: number;
}
export interface TransactionSendModel {
  Transaction: TransactionDto;
  Template: BasicMailDto;
}
export interface TransactionMoneyTransferDto {
  WorkingYearId: number;
  Description: string;
  Date: Date;
  Amount: number;
  FromFinancialPostId: number;
  ToFinancialPostId: number;
}

export interface TransactionImportType extends SelectOption {
  extensions: string[];
}

export interface VatValidationResponse {
  isValid: boolean;
  message: string | null;
  filledInVat: number;
  calculatedVat: number;
  percentage: number;
}
